export default function ($http, $q) {
    return function (reference) {
        if (!reference) {
            return $q.reject('No reference set');
        }

        return $http({
            method: 'GET',
            url: `/api/scannedLetter/${reference}`
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/services/letters/getLetterByReference.js